import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y } from "swiper/modules";

function buildSwiper(element) {
  if(typeof element.Swiper?.destroy !== 'undefined'){
    element.Swiper.destroy();
  }

  const postsType = element.dataset.type;
  const postsSource = element.dataset.source;
  const chooseFromUserLocation = !!parseInt(element.dataset.chooseFromUserLocation || null, 10);
  const firstFromUserLocation = !!parseInt(element.dataset.firstFromUserLocation || null, 10);
  const locationType = element.dataset.locationType || '';
  const hideIfEmpty = !!parseInt(element.dataset.hideIfEmpty || null, 10);
  const venue = get_current_venue_info();

  if(postsType == 'event' && postsSource == 'automatic'){
    if(firstFromUserLocation){
      const items = element.querySelectorAll('.swiper-slide');
      const locationItems = [];
      const remainingItems = [];

      items.forEach((item) => {
        const event = item.querySelector('article');
        const eventVenues = event.dataset.venues.split(',');

        if(eventVenues.length && !eventVenues.includes(venue.id.toString())){
          remainingItems.push(item);
        }else{
          locationItems.push(item);
        }
      });

      const sortedLocationItems = locationItems.sort((a, b) => {
        return parseInt(a.querySelector('article').dataset?.datetime, 10) - parseInt(b.querySelector('article').dataset?.datetime, 10);
      });

      const sortedRemainingItems = remainingItems.sort((a, b) => {
        return parseInt(a.querySelector('article').dataset?.datetime, 10) - parseInt(b.querySelector('article').dataset?.datetime, 10);
      });

      const sortedItems = sortedLocationItems.concat(sortedRemainingItems);
      const wrapper = element.querySelector('.swiper-wrapper');

      sortedItems.forEach(item => {
        wrapper.appendChild(item);
      });
    }

    if(chooseFromUserLocation){
      element.querySelectorAll('.swiper-slide article').forEach((article) => {
        const eventVenues = article.dataset.venues.split(',');
        if(eventVenues.length && !eventVenues.includes(venue.id.toString())){
          article.closest('.swiper-slide').classList.add('hidden!');
        }else{
          article.closest('.swiper-slide').classList.remove('hidden!');
        }
      });
    }
  }

  if(postsType == 'venue'){
    element.querySelectorAll('.swiper-slide article').forEach((article) => {
      const currentVenueId = article.dataset.venue;
      const currentVenue = get_venue_info(currentVenueId);
      if(get_is_happy_hour_at_venue(currentVenue)){
        article.querySelector('.happy-hour').classList.remove('hidden');
      }else{
        article.querySelector('.happy-hour').classList.add('hidden');
      }
    });
  }

  if(postsType == 'venue' && postsSource == 'automatic' && chooseFromUserLocation && locationType != ''){
    let fieldValue = locationType == 'country' ? venue.country : venue.province;

    element.querySelectorAll('.swiper-slide article').forEach((article) => {
      if(article.dataset[locationType] == fieldValue){
        article.closest('.swiper-slide').classList.remove('hidden!');
      }else{
        article.closest('.swiper-slide').classList.add('hidden!');
      }
    });
  }

  if(hideIfEmpty && element.querySelectorAll(".swiper-slide:not(.hidden\\!)").length == 0){
    element.closest('section').classList.add('hidden!');
  }else{
    element.closest('section').classList.remove('hidden!');
  }

  new Swiper(element, {
    modules: [Navigation, Pagination, Autoplay, A11y],
    slidesPerView: 1,
    breakpoints: {
      570: {
        slidesPerView: 2,
        autoHeight: false,
      },
      900: {
        slidesPerView: 3,
      },
    },
    breakpointsBase: 'container',
    spaceBetween: 40,
    simulateTouch: false,
    watchOverflow: false,
    autoHeight: element.dataset.autoplay != "1" ? true : false,
    navigation: {
      enabled: element.dataset.navigation == "1",
      prevEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .prev"),
      nextEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .next"),
    },
    pagination: {
      enabled: element.dataset.pagination == "1",
      el: element.closest(".swiper-parent").querySelector(".swiper-pagination"),
      clickable: true,
    },
    loop: element.dataset.loop == "1",
    autoplay:
      element.dataset.autoplay == "1"
      ? {
        delay: parseFloat(element.dataset.autoplayDelay) * 1000
      }
      : false,
  });
}

function buildDynamicContentSwiper() {
  document.querySelectorAll(".dynamic-content-swiper").forEach((element) => {
    buildSwiper(element);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if(get_current_venue_info()){
    buildDynamicContentSwiper();
  }
  document.body.addEventListener('venueChanged', buildDynamicContentSwiper);
});
